import React from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';

const EmployeeFilters = ({
    searchTerm,
    setSearchTerm,
    filters,
    handleFilterChange,
    handlePageChange
}) => {
    const clearFilters = () => {
        handleFilterChange('department', 'all');
        handleFilterChange('workStatus', 'all');
        handleFilterChange('contractType', 'all');
        setSearchTerm('');
        handlePageChange(1);
    };

    return (
        <Card className="mb-4">
            <Card.Header>
                <h6 className="mb-0">🔍 Arama ve Filtreleme</h6>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Arama</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Ad, TC, telefon ile ara..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Departman</Form.Label>
                            <Form.Select
                                value={filters.department}
                                onChange={(e) => handleFilterChange('department', e.target.value)}
                            >
                                <option value="all">Tümü</option>
                                <option value="satış">Satış</option>
                                <option value="muhasebe">Muhasebe</option>
                                <option value="insan_kaynakları">İnsan Kaynakları</option>
                                <option value="bilgi_işlem">Bilgi İşlem</option>
                                <option value="genel_koordinatör">Genel Koordinatör</option>
                                <option value="temizlik">Temizlik</option>
                                <option value="güvenlik">Güvenlik</option>
                                <option value="diğer">Diğer</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>İş Durumu</Form.Label>
                            <Form.Select
                                value={filters.workStatus}
                                onChange={(e) => handleFilterChange('workStatus', e.target.value)}
                            >
                                <option value="all">Tümü</option>
                                <option value="aktif">Aktif</option>
                                <option value="izinli">İzinli</option>
                                <option value="ayrılmış">Ayrılmış</option>
                                <option value="sözleşme_bitmiş">Sözleşme Bitmiş</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Sözleşme Türü</Form.Label>
                            <Form.Select
                                value={filters.contractType}
                                onChange={(e) => handleFilterChange('contractType', e.target.value)}
                            >
                                <option value="all">Tümü</option>
                                <option value="belirsiz_sureli">Belirsiz Süreli</option>
                                <option value="belirli_sureli">Belirli Süreli</option>
                                <option value="deneme_sureli">Deneme Süreli</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>&nbsp;</Form.Label>
                            <Button
                                className="w-100"
                                variant="danger"
                                onClick={clearFilters}
                            >
                                Temizle
                            </Button>
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default EmployeeFilters;